import Alpine from 'alpinejs'

window.Alpine = Alpine

// Start Alpine exactly once. `Alpine.isReady` is not a real property, so the old
// guard always re-ran Alpine.start() on turbo:load — on top of the initial start
// below — triggering "Alpine has already been initialized". Alpine 3's MutationObserver
// auto-initializes elements Turbo adds on navigation, so a single start() is correct.
function startAlpineOnce() {
  if (window.__alpineStarted) return
  window.__alpineStarted = true
  Alpine.start()
}

document.addEventListener('turbo:load', startAlpineOnce)

document.addEventListener('turbo:before-render', () => {
  // Clean up Alpine before Turbo replaces the DOM
  Alpine.destroyTree(document.body)
})

// Initial page load
startAlpineOnce()
